import { Mediaclip } from 'app/interfaces/mediaclip';
import { Subscription } from 'rxjs';
import { Publication } from './../interfaces/publication';
import { PublicationService } from './publication.service';
import { Injectable, OnDestroy } from '@angular/core';


@Injectable()
export class AssetService implements OnDestroy {
	publication: Publication;
	subscriptions = new Subscription();

	constructor(private publicationService: PublicationService) {
		this.publication = {} as Publication;
		this.subscriptions.add(this.publicationService.getData().subscribe((publicationData: Publication) => {
			this.publication = publicationData;
		}));
	}

	ngOnDestroy() {
		this.subscriptions.unsubscribe();
	}

	getAssetUrl(mediaclip?: Mediaclip, assetSrc?: string, forceDefaultPath = false): string {
		let assetUrl = assetSrc || mediaclip?.src;
		if (!assetUrl || !assetUrl.match || (!assetUrl.match(/^\w+:\/\//) && !assetUrl.match(/^\/\//))) { // non fully-qualified
			assetUrl = this.getAssetBaseUrl(mediaclip, forceDefaultPath) + (assetUrl || '');
		}
		return assetUrl;
	}

	getAssetBaseUrl(mediaclip?: Mediaclip, forceDefaultPath = false): string {
		if (!this.publication || !this.publication.defaultMediaAssetPath) {
			return '';
		}
		return this.getAssetPath(this.publication, mediaclip, forceDefaultPath);
	}

	getServerPath() {
		if (!this.publication || !this.publication.baseurl) {
			return '';
		}
		return this.publication.baseurl;
	}

	getMainThumbnailResizerUrl(id: string, w: number | string, h: number | string, ext: string, entityType: string = 'mediaclip') {
		if (!this.publication || !this.publication.baseurl) {
			return '';
		}
		ext = ext || 'jpg';
		w = w || 320;
		h = h || 180;
		return this.publication.baseurl + '/' + entityType + '/' + id + '/spthumbnail/' + w + '/' + h + '.' + ext;
	}

	getImageResizerUrl(url: string, w: number, h: number) {
		if (!this.publication || !this.publication.baseurl) {
			return '';
		}
		w = w || 320;
		h = h || 180;
		return this.publication.baseurl + '/image' + '/' + w + '/' + h + url;
	}

	getImageResizerBaseUrl(w: string | number, h: string | number) {
		if (!this.publication || !this.publication.baseurl) {
			return '';
		}
		w = w || 320;
		h = h || 180;
		return this.publication.baseurl + '/image' + '/' + w + '/' + h;
	}

	needsSecurePath(publication: Publication, mediaclip: Mediaclip): boolean {
		return publication?.secureMediaAssetPath && (publication?.cfSigning === 'all' || (publication?.cfSigning === 'exclusive' && mediaclip?.exclusive));
	}

	private getAssetPath(publication?: Publication, mediaclip?: Mediaclip, forceDefaultPath = false): string {
		if (!forceDefaultPath && this.needsSecurePath(publication, mediaclip)) {
			return publication.secureMediaAssetPath;
		}
		return publication.defaultMediaAssetPath;
	}
}
